import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { withModal } from 'components/modal/ModalHOC';
import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import NotesModal from '../modal/NotesModal';
import DiscoveryCreatorsFilterPopover from 'modules/freemium/components/discovery-creators-filter-popover/DiscoveryCreatorsFilterPopover';

import { isInfluencerInNotesSelector } from 'selectors/influencersMeta';
import { __t, applyTranslations } from 'utils/language';

import './notes-button.scss';

import type { InfluencerTile } from 'types';

applyTranslations(require('./notes-button.i18n.json'));

type OwnProps = {
  influencer: InfluencerTile,
  autoOpenModal: boolean,
  isFreemium?: boolean
};

type StateProps = {
  isActive: boolean
};

type Props = StateProps & OwnProps;

const TooltipWithModal = withModal(Tooltip, {
  modalContent: NotesModal
});

class NotesButton extends React.PureComponent<Props> {
  renderIconPopover(children: React.ReactNode): React.ReactNode {
    return (
      <DiscoveryCreatorsFilterPopover
        triggerComponent={children}
      />
    );
  }

  renderIcon(): React.ReactNode {
    const { isFreemium, isActive } = this.props;

    const triggerClasses = classnames('notes-button__trigger', {
      'notes-button__trigger--blocked': isFreemium
    });

    const iconClasses = classnames('notes-button__icon', {
      'notes-button__icon--blocked': isFreemium
    });

    return (
      <div className={triggerClasses}>
        <div className={iconClasses}>
          <SVGDynamicIcon
            name="notes-custom-fg"
            customColor={isActive ? 'primary' : 'grey'}
            clickable={!isFreemium}
            width={21}
            height={19}
          />
        </div>
      </div>
    );
  }

  renderContents(): React.ReactNode {
    const { isFreemium } = this.props;

    return isFreemium
      ? this.renderIconPopover(this.renderIcon())
      : this.renderIcon();
  }

  render(): React.ReactNode {
    const { influencer, autoOpenModal, isFreemium } = this.props;

    const tooltipClasses = classnames('notes-button__tooltip', {
      'notes-button__tooltip--blocked': isFreemium
    });

    if (isFreemium) {
      return this.renderContents();
    }

    return (
      <div>
        <TooltipWithModal
          autoOpenModal={autoOpenModal}
          message={__t('notes_button.tooltip_notes')}
          width="auto-compact"
          display="flex"
          className={tooltipClasses}
          modalContentProps={{ influencerProfile: influencer }}
        >
          {this.renderContents()}
        </TooltipWithModal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps: OwnProps): StateProps => ({
  isActive: isInfluencerInNotesSelector(state, ownProps)
});

export default connect(mapStateToProps)(NotesButton);
